<div class="portal">
  <ng-template cdkPortalOutlet />
</div>
<div class="tail"></div>
